import React from 'react';
import { ProjectFormData } from '../../types/project';
import { Select } from '../ui/select';

interface ProjectFormProps {
    formData: ProjectFormData;
    onFormDataChange: (data: Partial<ProjectFormData>) => void;
    onSoundworldSelect: () => void;
    selectedSoundworldPretty?: string;
}

export const ProjectForm: React.FC<ProjectFormProps> = ({
    formData,
    onFormDataChange,
    onSoundworldSelect,
    selectedSoundworldPretty
}) => {
    const sectionTypeOptions = [
        { value: 'intro', label: 'Intro' },
        { value: 'verse', label: 'Verse' },
        { value: 'chorus', label: 'Chorus' },
        { value: 'instrumental', label: 'Instrumental' },
        { value: 'breakdown', label: 'Breakdown' },
        { value: 'outro', label: 'Outro' }
    ];

    return (
        <div className="mt-6 w-full max-w-md space-y-4">
            <input
                type="text"
                placeholder="Project name"
                value={ formData.projectName }
                onChange={ (e) => onFormDataChange({ projectName: e.target.value }) }
                className="w-full border border-border rounded px-3 py-2 text-sm cursor-text bg-background text-card-foreground placeholder:text-muted-foreground"
            />
            <input
                type="text"
                placeholder="Description (optional)"
                value={ formData.description }
                onChange={ (e) => onFormDataChange({ description: e.target.value }) }
                className="w-full border border-border rounded px-3 py-2 text-sm cursor-text bg-background text-card-foreground placeholder:text-muted-foreground"
            />
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-card-foreground">Choose a soundworld:</span>
                        <button
                            onClick={ onSoundworldSelect }
                            className="bg-muted px-3 py-1 rounded text-sm cursor-pointer hover:bg-accent transition-colors text-card-foreground"
                        >
                            { selectedSoundworldPretty || formData.soundworld || 'Select soundworld' }
                        </button>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-card-foreground">Loop mode:</span>
                        <input
                            type="checkbox"
                            id="loopMode"
                            checked={ formData.loopMode }
                            onChange={ (e) => onFormDataChange({ loopMode: e.target.checked }) }
                            className="rounded border-border cursor-pointer accent-primary"
                        />
                    </div>
                </div>
            </div>
            <div>
                { formData.loopMode && (
                    <>
                        <label htmlFor="sectionType" className="text-sm font-medium block mb-2 text-card-foreground">Section type:</label>
                        <Select
                            value={ formData.sectionType }
                            onChange={ (value) => onFormDataChange({ sectionType: value }) }
                            options={ sectionTypeOptions }
                            placeholder="Select section type"
                        />
                    </>
                ) }
            </div>
        </div>
    );
}; 